import React from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { convertAmount, parseNumberByPrecision, useTranslation } from '@pascal/pascal-core';

import { winningStore } from '../../store/winningStore';
import { TranslationKeys } from '../../enums/translationKeys';

export const WinPopUp = observer(() => {
  const { isWin, winningAmount, demoWinningAmount } = winningStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();

  const win = winningAmount || demoWinningAmount;

  return (
    isWin &&
    win && (
      <div className='action-result-block'>
        <h6 className='action-result-block-title'>{t(TranslationKeys.YouWin)}</h6>
        <span>{`${convertAmount(parseNumberByPrecision(win, 1, 2))} ${currencySymbolOrCode}`}</span>
      </div>
    )
  );
});
